import { CircularProgressState } from "./types";

export const getDefaultAriaLabel = (state: CircularProgressState, clampedProgress: number) => {
  switch (state) {
    case "completed":
      return "Completed";
    case "in-progress":
      return `In progress: ${Math.round(clampedProgress)}% complete`;
    case "not-started":
      return "Not started";
    default:
      return "Progress indicator";
  }
};
